import api from '@baza/store/api';

const state = {
    items: [],
    item: {},
    load: false,
    sent: false,
    showViewer: {
        value: false,
        index: 0,
    },
    form: {
        phone: {
            value: '',
            require: true,
            error: false,
            type: 'phone',
            errorType: 'require',
            errorText: 'Обязательное поле',
        },
        name: {
            value: '',
            require: true,
            error: false,
            type: 'text',
            errorType: 'require',
            errorText: 'Обязательное поле',
        },
        email: {
            value: '',
            require: true,
            error: false,
            type: 'email',
            errorType: 'require',
            errorText: 'Обязательное поле',
        },
        comment: {
            value: '',
            require: false,
            error: false,
            type: 'text',
            errorType: 'require',
        },
        checkboxPersonal: {
            value: false,
            require: true,
            error: false,
            type: 'check',
            errorType: 'require',
        },

    },
};

const getters = {};
const actions = {
    getItem(context, data) {
        if (Object.keys(context.state.item).length > 0) {
            return;
        }
        context.commit('setLoad', true);
        api.get(`/landing/${data}`, {}).then((r) => {
            context.commit('setItem', r);
            context.commit('setLoad', false);
        });
    },
};
const mutations = {
    setLoad(state, data) {
        state.load = data;
    },
    setItem(state, data) {
        state.item = data;
    },
    setSent(state, data) {
        state.sent = data;
    },
    setShowViewer(state, data) {
        state.showViewer = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
